<template>
  <b-card>
    <div class="section-container">
      <b-row align-v="center">
        <b-col>
          <h4 class="text-uppercase section-title text-info font-weight-bold mb-0">
            <i class="fas fa-user mr-1"></i> Personal Details
          </h4>
        </b-col>
      </b-row>

      <b-row class="py-1 align-items-center border-bottom">
        <b-col md="2" class="capitalize">Name</b-col>
        <b-col md="4">
          {{ details.first_name ? details.first_name : null }} {{ details.last_name ? details.last_name : null }}
        </b-col>
        <b-col md="2" class="capitalize">Date of Birth</b-col>
        <b-col md="4">
          {{ details.birth_date ? formatDate(details.birth_date) : null }}
        </b-col>
      </b-row>

      <b-row class="py-1 align-items-center border-bottom">
        <b-col md="2" class="capitalize">Gender</b-col>
        <b-col md="4">
          {{ details.gender ? capitalizeFirstLetter(details.gender) : null }}
        </b-col>
        <b-col md="2" class="capitalize">Aadhaar Number</b-col>
        <b-col md="4">
          {{ details.profile.aadhaar_card_no ? details.profile.aadhaar_card_no : null }}
        </b-col>
      </b-row>

      <b-row class="py-1 align-items-center border-bottom">
        <b-col md="2" class="capitalize">Email</b-col>
        <b-col md="4">
          {{ details.email ? details.email : null }}
        </b-col>
        <b-col md="2" class="capitalize">Phone Number</b-col>
        <b-col md="4">
          {{ details.mobile ? details.mobile : null }}
        </b-col>
      </b-row>

      <b-row class="py-1 align-items-center border-bottom">
        <b-col md="2" class="capitalize">Blood Group</b-col>
        <b-col md="4">
          {{ details.profile.blood_group ? details.profile.blood_group.toUpperCase() : null }}
        </b-col>
        <b-col md="2" class="capitalize">Reservation Category</b-col>
        <b-col md="4">
          {{ details.profile.reservation_category ? capitalizeFirstLetter(details.profile.reservation_category) : null
          }}
        </b-col>
      </b-row>

      <b-row class="py-1 align-items-center border-bottom">
        <b-col md="2" class="capitalize">Religion</b-col>
        <b-col md="4">
          {{ details.profile.religion ? capitalizeFirstLetter(details.profile.religion) : null }}
        </b-col>
        <b-col md="2" class="capitalize">Caste</b-col>
        <b-col md="4">
          {{ details.profile.caste ? capitalizeFirstLetter(details.profile.caste) : null }}
        </b-col>
      </b-row>

      <b-row class="py-1 align-items-center border-bottom">
        <b-col md="2" class="capitalize">Permanent Address</b-col>
        <b-col md="10">
          {{
            [
              details.profile.house_name_permanent_address,
              details.profile.town_permanent_address,
              details.profile.district_permanent_address,
              details.profile.state_permanent_address,
              details.profile.country_permanent_address
            ]
              .filter(Boolean)
              .join(', ') +
            (details.profile.pincode_permanent_address ? ` - ${details.profile.pincode_permanent_address}` : '')
          }}
        </b-col>
      </b-row>

      <b-row class="py-1 align-items-center">
        <b-col md="2" class="capitalize">Communication Address</b-col>
        <b-col md="10">
          {{
            [
              details.profile.house_name_communication_address,
              details.profile.town_communication_address,
              details.profile.district_communication_address,
              details.profile.state_communication_address,
              details.profile.country_communication_address
            ]
              .filter(Boolean)
              .join(', ') +
            (details.profile.pincode_communication_address ? ` - ${details.profile.pincode_communication_address}` : '')
          }}
        </b-col>
      </b-row>

    </div>
  </b-card>
</template>

<script>
export default {
  props: {
    details: {
      type: [Object, Array],
      required: true,
    },
  },
  methods: {
    capitalizeFirstLetter(text) {
      if (!text) return '';
      return text
        .replace(/_/g, ' ')
        .replace(/\b\w/g, (char) => char.toUpperCase());
    },
    formatDate(date) {
      if (!date) return '';
      const d = new Date(date);
      return d.toLocaleDateString('en-GB');
    }
  }
};
</script>
<style scoped>
.section-container {
  padding: 14px;
  background-color: #f9f9f9;
  border-radius: 0px;
}

.capitalize {
  text-transform: capitalize;
}
</style>